"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var config_1 = require("../../config");
var context_1 = require("../../context");
var hooks_1 = require("../../hooks");
var styles_1 = require("../../styles");
var SmallLabel_1 = __importDefault(require("./SmallLabel"));
var Tooltip_1 = __importDefault(require("./Tooltip"));
var USD = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, value = _a.value, _c = _a.className, className = _c === void 0 ? "" : _c, prefix = _a.prefix, _d = _a.suffix, suffix = _d === void 0 ? "" : _d, emptyUi = _a.emptyUi, onlyValue = _a.onlyValue;
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: value });
    var formattedValueTooltip = (0, hooks_1.useFormatNumber)({ value: value, decimalScale: 18 });
    var _e = (0, context_1.useTwapContext)().uiPreferences, usdSuffix = _e.usdSuffix, usdPrefix = _e.usdPrefix, usdEmptyUI = _e.usdEmptyUI;
    var _prefix = prefix || usdPrefix || "".concat(config_1.SQUIGLE, " $ ");
    var _suffix = suffix || usdSuffix;
    var _emptyUi = emptyUi || usdEmptyUI;
    if (value == null)
        return null;
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, __assign({ text: "".concat(formattedValueTooltip), placement: "bottom" }, { children: (0, jsx_runtime_1.jsx)(StyledLabel, __assign({ loading: isLoading, className: "twap-usd ".concat(className, " ").concat(value === "0" ? "twap-usd-zero" : "", " ") }, { children: value == 0 && emptyUi ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: _emptyUi })) : onlyValue ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: formattedValue })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [_prefix, (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: formattedValue || "0" }), _suffix] })) })) })));
};
exports.default = USD;
var StyledLabel = (0, material_1.styled)(SmallLabel_1.default)(__assign(__assign({ overflow: "hidden" }, styles_1.textOverflow), { minWidth: "0px" }));
